import './activationModal.scss';
import template from './keychainRemoteModal.html';

class KeychainRemoteModalController {
    /*@ngInject*/
    constructor () {
        
    }
}

export default {
    template: template,
    bindings: { },
    controller: KeychainRemoteModalController
};